import axios from "axios";
//http client
import configData from "./../configData";
import { tokenConfig } from "./authActions";
import {
  LOGOUT_SUCCESS,
  PWD_UPDATE_ERROR,
  USER_CHANGE_LANGUAGE,
  USER_NOTIFICATION,
  USER_PASSWORD,
  USER_PRICING,
  USER_RECORDER,
  USER_SELECTION,
  USER_UPDATE_ERROR,
  USER_UPDATE_SUCCESS,
  USER_UPDATED,
  USER_HISTORY,
} from "./types";
// import { returnErrors } from "./errorActions";

export const changeLanguage = (lang) => (dispatch) => {
  dispatch({ type: USER_CHANGE_LANGUAGE, payload: lang });
};

export const changePricing = (price) => (dispatch) => {
  dispatch({ type: USER_PRICING, payload: price });
};

export const changeUserSelection = (selection) => (dispatch) => {
  dispatch({ type: USER_SELECTION, payload: selection });
};

export const changeUserHistoryArr = (historyArr) => (dispatch) => {
  dispatch({ type: USER_HISTORY, payload: historyArr });
};

export const getUser = (user) => (dispatch, getState) => {
  // dispatch for redux thunk
  // if (favorites.itemID !== undefined) {
  // consoel.log("ok")
  // dispatch({ type: USER });

  axios
    .get(`${configData.SERVER_URL}users`, tokenConfig(getState))
    .then((res) =>
      // axios will prevent us from doing httpRequest..
      //https://github.com/axios/axios;
      {
        dispatch({
          type: USER_UPDATED,
          payload: res.data,
          // sending data a payload to reducer
        });
      }
    )
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              dispatch({
                type: LOGOUT_SUCCESS,
              });
            }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      // dispatch(returnErrors(err.response.data, err.response.status));
    });
  // }
  // }
};

export const updateUser = (user) => (dispatch, getState) => {
  // dispatch for redux thunk
  // if (favorites.itemID !== undefined) {
  // consoel.log("ok")
  // dispatch({ type: USER });
  dispatch({
    type: USER_NOTIFICATION,
    payload: user.hasOwnProperty("language") ? "Loaded" : "Loading...",
  });
  // setTimeout(() => {
  //   dispatch({
  //     type: USER_NOTIFICATION,
  //     payload: "",
  //   });
  // }, 15000);
  if (user.pwd !== undefined) {
    // dispatch({
    //   type: PWD_UPDATE_SUCCESS,
    //   payload: "Loading...",
    // });
    // setTimeout(() => {
    //   dispatch({
    //     type: PWD_UPDATE_SUCCESS,
    //     payload: "",
    //   });
    // }, 5000);
  }

  if (user.offer === "free") {
    dispatch({
      type: USER_UPDATE_SUCCESS,
      payload: {
        user: {
          language: user.language,
        },
      },
    });
  } else {
    axios
      .post(`${configData.SERVER_URL}users/123`, user, tokenConfig(getState))
      .then((res) =>
        // axios will prevent us from doing httpRequest..
        //https://github.com/axios/axios;
        {
          if (user.pwd !== undefined) {
            console.log("user update", res);
            if (user.hasOwnProperty("favorites")) {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "Password updated.",
              });
            }
            if (res.data.token) {
              dispatch({
                type: USER_PASSWORD,
                payload: res.data,
              });
              dispatch({
                type: USER_NOTIFICATION,
                payload: "User password updated.",
              });
            }
            setTimeout(() => {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "",
              });
            }, 5000);
          } else {
            dispatch({
              type: USER_UPDATE_SUCCESS,
              payload: res.data,
            });
            if (user.firstName) {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "User name updated.",
              });
            } else if (user.dateFormat) {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "Date format updated.",
              });
            } else {
              dispatch({
                type: USER_NOTIFICATION,
                payload:
                  user.hasOwnProperty("favorites") ||
                  user.hasOwnProperty("role")
                    ? "Updated."
                    : "Finished",
              });
            }
            setTimeout(() => {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "",
              });
            }, 5000);
          }
        }
      )
      .catch((error) => {
        if (error.response) {
          console.log("error", error.response.data);
          // Request made and server responded
          if (user.pwd !== undefined) {
            dispatch({
              type: PWD_UPDATE_ERROR,
              payload: error.response.data.res,
            });
            setTimeout(() => {
              dispatch({
                type: PWD_UPDATE_ERROR,
                payload: "",
              });
            }, 5000);
          } else if (user.firstName) {
            dispatch({
              type: USER_NOTIFICATION,
              payload: "Problem to update name.",
            });
            setTimeout(() => {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "",
              });
            }, 4000);
          } else if (user.dateFormat) {
            dispatch({
              type: USER_NOTIFICATION,
              payload: "Problem to update date format.",
            });
            setTimeout(() => {
              dispatch({
                type: USER_NOTIFICATION,
                payload: "",
              });
            }, 4000);
          } else {
            dispatch({
              type: USER_UPDATE_ERROR,
              payload: error.response.data.res,
            });
            setTimeout(() => {
              dispatch({
                type: USER_UPDATE_ERROR,
                payload: "",
              });
            }, 5000);
          }
          if (error.response.data)
            if (error.response.data.res)
              if (
                error.response.data.res.includes("err token or user undefined")
              ) {
                console.log("error", error.response);
                dispatch({
                  type: LOGOUT_SUCCESS,
                });
              }
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        // dispatch(returnErrors(err.response.data, err.response.status));
      });
  }

  // }
  // }
};

// export const getFavorites = (favorites) => (dispatch, getState) => {
//   // dispatch for redux thunk
//   console.log("getFavorites action", favorites);
//   if (favorites !== undefined) {
//     console.log("ok");
//     // if (favorites.itemID !== undefined) {
//     // consoel.log("ok")
//     dispatch({ type: FAVORITES_LOADING });

//     axios
//       .post(
//         `https://rv8udpmnfg.execute-api.eu-central-1.amazonaws.com/prod2/users/1`,
//         favorites,
//         tokenConfig(getState)
//       )
//       .then((res) =>
//         // axios will prevent us from doing httpRequest..
//         //https://github.com/axios/axios
//         {
//           console.log("getFavorites res", res);
//           dispatch({
//             type: GET_FAVORITES,
//             payload: res.data,
//             // sending data as payload to reducer
//           });
//         }
//       )
//       .catch((error) => {
//         if (error.response) {
//           // Request made and server responded
//           console.log(error.response.data);
//           console.log(error.response.status);
//           console.log(error.response.headers);
//           if (error.response.data.res.includes("err token or user undefined"))
//             dispatch({
//               type: LOGOUT_SUCCESS,
//             });
//         } else if (error.request) {
//           // The request was made but no response was received
//           console.log(error.request);
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           console.log("Error", error.message);
//         }
//         // dispatch(returnErrors(err.response.data, err.response.status));
//       });
//   }
//   // }
// };

// export const updateFavorites = (favorites) => (dispatch, getState) => {
//   // dispatch for redux thunk
//   console.log("updateFavorites action", favorites);
//   dispatch({ type: FAVORITES_LOADING });
//   if (favorites !== undefined) {
//     if (favorites.itemID !== undefined) {
//       axios
//         .post(
//           `https://rv8udpmnfg.execute-api.eu-central-1.amazonaws.com/prod2/users/${favorites.itemID}`,
//           favorites,
//           tokenConfig(getState)
//         )
//         .then((res) =>
//           // axios will prevent us from doing httpRequest..
//           //https://github.com/axios/axios

//           dispatch({
//             type: UPDATE_FAVORITE,
//             payload: res.data,
//             // sending data as payload to reducer
//           })
//         )
//         .catch((error) => {
//           if (error.response) {
//             // Request made and server responded
//             console.log(error.response.data);
//             console.log(error.response.status);
//             console.log(error.response.headers);
//             if (error.response.data.res.includes("err token or user undefined"))
//               dispatch({
//                 type: LOGOUT_SUCCESS,
//               });
//           } else if (error.request) {
//             // The request was made but no response was received
//             console.log(error.request);
//           } else {
//             // Something happened in setting up the request that triggered an Error
//             console.log("Error", error.message);
//           }
//         });
//     } else {
//       console.log("problem favorite.itemID undefined");
//     }
//   }
// };

// export const deleteFavorite = (id) => (dispatch, getState) => {
//   // dispatch for redux thunk
//   console.log("deletefav action", id);
//   // dispatch({ type: DELETE_FAVORITE });

//   axios
//     .delete(
//       `https://rv8udpmnfg.execute-api.eu-central-1.amazonaws.com/prod2/users/${id}`,
//       tokenConfig(getState)
//     )
//     .then((res) =>
//       // axios will prevent us from doing httpRequest..
//       //https://github.com/axios/axios

//       dispatch({
//         type: DELETE_FAVORITE,
//         payload: res.data,
//         // sending data as payload to reducer
//       })
//     )
//     .catch((error) => {
//       if (error.response) {
//         // Request made and server responded
//         console.log(error.response.data);
//         console.log(error.response.status);
//         console.log(error.response.headers);
//         if (error.response.data.res.includes("err token or user undefined"))
//           dispatch({
//             type: LOGOUT_SUCCESS,
//           });
//       } else if (error.request) {
//         // The request was made but no response was received
//         console.log(error.request);
//       } else {
//         // Something happened in setting up the request that triggered an Error
//         console.log("Error", error.message);
//       }
//       // dispatch(returnErrors(err.response.data, err.response.status));
//     });
// };
//request to backend

export const updateRecorder = (recorder) => (dispatch, getState) => {
  dispatch({
    type: USER_RECORDER,
    payload: recorder,
  });
};
